exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv.btn__content[data-v-2d61e639] {\n  padding: 50px;\n}\ndiv.card__actions .btn[data-v-2d61e639] {\n  min-width: 131px;\n}\n.button-styling[data-v-2d61e639] {\n  font-family: Avenir !important;\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n", ""]);

